import React from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Card from '@jobseeker/lotus/components/Card';
import HiristBanner from '@jobseeker/lotus/components/HiristBanner';
import BannerInfo from '@jobseeker/lotus/components/BannerInfo';
import {BannerTick} from '@jobseeker/lotus/assets/icons';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import HomePageFooter from '@components/HomeV2/homePageFooter';

type GrievancesProps = {
  isMobile?: boolean;
};

type GrievanceOfficer = {
  officerName: string;
  address: string;
  email: string;
};

const Grievances = ({isMobile}: GrievancesProps) => {
  const interceptor = useInterceptor() as {grievances?: GrievanceOfficer};
  const {
    officerName = '',
    address = '',
    email = '',
  } = interceptor.grievances ?? {};
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const bodyTextSx = {
    fontSize: isAppIimjobs ? '14px' : '16px',
    lineHeight: isAppIimjobs ? '24px' : '28px',
    color: 'text.primary',
  };

  return (
    <Box>
      {!isAppIimjobs && (
        <HiristBanner>
          <BannerInfo
            Icon={BannerTick}
            isMobile={!!isMobile}
            subTitle={'Grievances'}
            title={''}
          />
        </HiristBanner>
      )}
      <Box
        sx={{
          maxWidth: isAppIimjobs ? '1050px' : 'none',
          margin: '0 auto',
          padding: isAppIimjobs
            ? {xxs: '24px 0px 0px'}
            : {xxs: '12px 10px', md: '40px 30px', lg: '40px 50px'},
        }}
      >
        <Card
          variant=""
          heading=""
          sx={{
            borderRadius: isAppIimjobs ? '15px' : '8px',
            padding: {xxs: '24px 20px', md: '40px'},
            minHeight: isAppIimjobs
              ? 'auto'
              : {xxs: 'calc(100vh - 174px)', md: 'calc(100vh - 280px)'},
          }}
        >
          <Typography
            component="h1"
            sx={{
              fontFamily: isAppIimjobs ? 'Poppins' : 'inherit',
              fontSize: {xxs: '20px', md: '24px'},
              fontWeight: isAppIimjobs ? 500 : 700,
              lineHeight: '30px',
              color: isAppIimjobs ? 'secondary.dark' : 'text.primary',
              textAlign: isAppIimjobs ? 'center' : 'left',
              textTransform: isAppIimjobs ? 'uppercase' : 'none',
              mb: {xxs: 3, md: 4},
            }}
          >
            Grievance Officer
          </Typography>
          <Box component="address" sx={{fontStyle: 'normal'}}>
            <Typography sx={bodyTextSx}>{officerName}</Typography>
            {address.split('<br>').map((line: string) => (
              <Typography key={line} sx={bodyTextSx}>
                {line}
              </Typography>
            ))}
            <Typography sx={bodyTextSx}>
              Email:{' '}
              <Box
                component="a"
                href={`mailto:${email}`}
                data-testid="grievance-officer-email"
                sx={{
                  color: 'primary.main',
                  fontWeight: isAppIimjobs ? 400 : 600,
                  textDecoration: 'none',
                  wordBreak: 'break-word',
                  '&:hover': {textDecoration: 'underline'},
                }}
              >
                {email}
              </Box>
            </Typography>
          </Box>
        </Card>
      </Box>

      {!isAppIimjobs && (
        <Box sx={{marginBottom: '-64px'}}>
          <HomePageFooter isTransparent={true} />
        </Box>
      )}
    </Box>
  );
};

export default Grievances;
